import { render } from "./ConfigureEmailEditPane.vue?vue&type=template&id=661280e7&scoped=true&ts=true"
import script from "./ConfigureEmailEditPane.vue?vue&type=script&lang=ts"
export * from "./ConfigureEmailEditPane.vue?vue&type=script&lang=ts"

import "./ConfigureEmailEditPane.vue?vue&type=style&index=0&id=661280e7&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661280e7"]])

export default __exports__